import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

export default {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientId() {
    return store.getters['Client/clientId']
  },
  getClientIdFreeroom() {
    return store.getters['Client/clientIdFreeroom']
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getNotificationGroups() {
    return Axios.get(`api/v1/clients/${this.getClientId()}/notification-groups`)
  },
  getAvailablePlaces(type) {
    if (type === strings.notificationGroupType.serviceDesk) {
      return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/names?onlyActive=true`)
    }
    return Axios.get(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/notificationgroups/availableRooms`)
  },
  getAvailableUsers(type) {
    if (type === strings.notificationGroupType.serviceDesk) {
      return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/notificationGroups/${type}/administrators`)
    }
    return Axios.get(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/notificationgroups/${type}/availableUsers`)
  },
  saveGroup(group) {
    if(group.id){
      return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/notificationGroups/${group.id}`, group)
    } 
    if(group.type === strings.notificationGroupType.serviceDesk) {
      return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/notificationGroups`, group)
    }
    return Axios.put(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/notificationgroups`, group)
  },
  deleteGroup(groupId){
    return Axios.delete(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/notificationGroups/` + groupId)
  }
}
